﻿'use strict'

module.exports = {
	parse: require('./parse'),
	stringify: require('./stringify')
}
